import React, { useContext, useEffect, useState } from "react";
import { Static2Map1Set, Year1Set } from "../App";
import { useDidUpdateEffect } from "../hooks/useDidUpdateEffect";

export const ButtonYears = () => {
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const [repeat, setRepeat] = useState(false);

  // console.log(year1set);

  let years = ["year1", "year2", "year3", "year4", "year5", "year6", "year7", "year8", "year9", "year10", "year11", "year12", "year13", "year14", "year15"];
  let year1s = [3000];
  {
    years.map((item) => {
      if (static2map1set[item]) {
        year1s.push(static2map1set[item]);
        // console.log(static2map1set[item]);
      }
    });
  }

  const handleChange = (e) => {
    setYear1Set(Number(e.target.value));
    setRepeat(false);
  };

  const handleChangerepeat = (e) => {
    if (repeat) {
      setRepeat(false);
    } else {
      setRepeat(true);
    }
  };

  const [timecount, setTimecount] = useState(-1);
  useEffect(() => {
    if (repeat) {
      const interval = setInterval(() => {
        setTimecount((c) => c + 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [repeat]);

  useDidUpdateEffect(() => {
    setYear1Set(Number(year1s[timecount % year1s.length]));
  }, [timecount]);

  // useEffect(() => {
  //   if(repeat){
  //     let time = 0
  //     setTimeout(function(){setYear1Set(Number(year1s[0]))}, time);
  //     setTimeout(function(){setYear1Set(Number(year1s[1]))}, time+1000);
  //     setTimeout(function(){setYear1Set(Number(year1s[2]))}, time+1000*2);
  //     setTimeout(function(){setYear1Set(Number(year1s[0]))}, time+1000*3);
  //     setTimeout(function(){setYear1Set(Number(year1s[1]))}, time+1000*4);
  //     setTimeout(function(){setYear1Set(Number(year1s[2]))}, time+1000*5);
  //   } else {
  //     console.log("繰り返しOFF");
  //   }
  // },[ repeat ])

  return (
    <>
      <main className="flex md:my-3 md:mx-2 items-center justify-center pointer-events-auto">
        <div
          className="flex md:rounded-xl bg-gray-200 p-1 md:py-1"
          x-data="app"
        >
          <div>
            <input
              name="year1repeat"
              id="連続表示"
              type="checkbox"
              // value="連続表示"
              onChange={handleChangerepeat}
              checked={true == repeat}
              className="peer hidden"
            />
            <label
              htmlFor="連続表示"
              className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
            >
              連続表示
            </label>
          </div>
        </div>
        <div
          className="flex md:rounded-xl bg-gray-200 p-1 md:py-1"
          x-data="app"
        >
          {year1s.map((item) => {
            return (
              <div key={item}>
                <input
                  name="year1set"
                  id={item}
                  type="radio"
                  value={item}
                  onChange={handleChange}
                  checked={item == year1set}
                  className="peer hidden"
                />
                {item == 3000 && (
                  <label
                    htmlFor={item}
                    className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
                  >
                    非表示
                  </label>
                )}
                {item != 3000 && (
                  <label
                    htmlFor={item}
                    className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
                  >
                    {item}年
                  </label>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </>
  );
};
